window.commentsFormToggle = function (node) {
    let allFormsNode = node.closest('.js-comments-wrapper').querySelectorAll('.js-comments__item-form--visible');
    let skip = false;

    if (node.closest('.js-comments__item').querySelector('.js-comments__item-form').classList.contains('js-comments__item-form--visible')) {
        skip = true;
    }

    allFormsNode.forEach(itemNode => {
        if (itemNode.classList.contains('js-comments__item-form--visible')) {
            itemNode.classList.remove('js-comments__item-form--visible');
        }
    });

   if (! skip) {
       node.closest('.js-comments__item').querySelector('.js-comments__item-form').classList.toggle('js-comments__item-form--visible');
   }
};